import { render, staticRenderFns } from "./userDepartment.vue?vue&type=template&id=fe8912e6&scoped=true"
import script from "./userDepartment.vue?vue&type=script&lang=js"
export * from "./userDepartment.vue?vue&type=script&lang=js"
import style0 from "./userDepartment.vue?vue&type=style&index=0&id=fe8912e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8912e6",
  null
  
)

export default component.exports